import type { ActivityKind } from '@erp/shared';
import {
  CalendarClock,
  Handshake,
  ListTodo,
  Mail,
  MapPin,
  MessageCircle,
  Phone,
  type LucideIcon,
} from 'lucide-react';

import { cn } from '../../lib/cn.ts';

export const KIND_ICONS: Record<ActivityKind, LucideIcon> = {
  call: Phone,
  whatsapp: MessageCircle,
  email: Mail,
  visit: MapPin,
  meeting: Handshake,
  task: ListTodo,
  other: CalendarClock,
};

// Literal class names (Tailwind only generates classes it can see). The block is a
// light tint of the type's color with a solid left edge; the text stays foreground
// (readable in both themes).
export const BLOCK: Record<string, string> = {
  slate: 'border-slate-500 bg-slate-500/15',
  red: 'border-red-500 bg-red-500/15',
  orange: 'border-orange-500 bg-orange-500/15',
  amber: 'border-amber-500 bg-amber-500/15',
  green: 'border-green-500 bg-green-500/15',
  teal: 'border-teal-500 bg-teal-500/15',
  blue: 'border-blue-500 bg-blue-500/15',
  violet: 'border-violet-500 bg-violet-500/15',
  pink: 'border-pink-500 bg-pink-500/15',
};

export const DOT: Record<string, string> = {
  slate: 'bg-slate-500',
  red: 'bg-red-500',
  orange: 'bg-orange-500',
  amber: 'bg-amber-500',
  green: 'bg-green-500',
  teal: 'bg-teal-500',
  blue: 'bg-blue-500',
  violet: 'bg-violet-500',
  pink: 'bg-pink-500',
};

/** The type's icon on a dot of its color. */
export function TypeIcon({
  kind,
  color,
  className,
}: {
  kind: ActivityKind;
  color: string;
  className?: string;
}) {
  const Icon = KIND_ICONS[kind];
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid size-8 shrink-0 place-items-center rounded-full text-white',
        DOT[color] ?? DOT.blue,
        className,
      )}
    >
      <Icon className="size-4" />
    </span>
  );
}
